import { findIndex } from '@/utils';
import Vue from 'vue';
import axios from 'axios';

export default {
  namespaced: true,
  state: {
    users: [],
    user: null,
    userForm: false,
    operation: null,
    pending: false,
    generatedPassword: null
  },
  mutations: {
    setUsers(state, users) {
      state.users = users;
    },
    setUser(state, user) {
      state.user = user;
    },
    appendUser(state, user) {
      const found = state.users.find(u => u.id == user.id);
      if (!found) {
        state.users.push(user);
        state.user = user;
      }
    },
    replace(state, { o, n }) {
      const i = findIndex(state.users, { id: o.id });
      if (i !== -1) Vue.set(state.users, i, n);
      state.user = n;
    },
    update(state, { o, n }) {
      const i = findIndex(state.users, { id: o.id });
      if (i !== -1) Vue.set(state.users, i, { ...state.users[i], ...n });
      state.user = { ...state.user, ...n };
    },
    remove(state, id) {
      const i = findIndex(state.users, { id });
      Vue.delete(state.users, i);
    },
    toggleUserForm(state, operation) {
      if (operation === 'create') state.user = {};
      state.operation = operation;
      state.userForm = !state.userForm;
    },
    clearGeneratedPassword(state) {
      state.generatedPassword = null;
    },
    clearState(state) {
      state.users = [];
      state.user = null;
      state.userForm = false;
      state.operation = null;
      state.pending = false;
      state.generatedPassword = null;
    }
  },
  actions: {
    async fetchUsers({ state, commit }) {
      try {
        state.pending = true;
        const res = await axios.get('/users');
        if (res && res.data) commit('setUsers', res.data.users);
      } finally {
        state.pending = false;
      }
    },
    async createUser({ commit }, user) {
      const res = await axios.post(`/users`, user);
      if (res && res.data) commit('appendUser', res.data.user);
    },
    async updateUser({ commit }, user) {
      user.id = parseInt(user.id);
      const res = await axios.patch(`/users/${user.id}`, user);
      if (res && res.data) commit('replace', { o: user, n: res.data.user });
    },
    async toggleUser({ commit }, user) {
      const res = await axios.patch(`/users/${user.id}`);
      if (res && res.data) commit('update', { o: { id: user.id }, n: res.data.user });
    },
    async deleteUser({ commit }, { id }) {
      const res = await axios.delete(`/users/${id}`);
      if (res && res.data) commit('remove', id);
    },
    async generatePassword({ state }, id) {
      const res = await axios.post(`/users/${id}/generate-password`);
      if (res && res.data) {
        state.generatedPassword = res.data.newPassword;
        state.user.password = res.data.newPasswordHash;
      }
    }
  }
};
